export default __webpack_public_path__ + "static/media/house-3.249d0e2a.jpeg";